import React, { useState } from 'react';
import { TextFieldProps } from '@lifeomic/chroma-react/components/TextField';
import MarkdownEditor, {
  convertEditorStateToMarkdown,
  initializeEditorState,
} from '@lifeomic/phc-web-toolkit/src/components/MarkdownEditor';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { EditorState } from 'draft-js';
import { Text } from '@lifeomic/chroma-react/components/Text';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  editor: {
    backgroundColor: theme.palette.grey[200],
    minHeight: theme.spacing(30),
  },
}));

export type MarkdownFieldProps = TextFieldProps & {
  value: string;
  onChange: (value: string) => void;
};

const MarkdownField: React.FC<MarkdownFieldProps> = ({
  value,
  onChange,
  label,
  disabled,
  ...rest
}) => {
  const styles = useStyles({});
  const [editorState, setEditorState] = useState(initializeEditorState(value));

  const handleOnChange = (editorState: EditorState) => {
    const markdown = convertEditorStateToMarkdown(editorState);
    onChange(markdown);
    setEditorState(editorState);
  };

  return (
    <div className={styles.root}>
      <Text size="subbody" weight="bold" className={styles.label}>
        {label}
      </Text>
      <MarkdownEditor
        {...rest}
        value={editorState}
        isEditing={!disabled}
        onChange={handleOnChange}
        editorClassName={styles.editor}
      />
    </div>
  );
};

export default React.memo(MarkdownField);
